import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDoubleExclamationIcon,
  AlertExclamationIcon,
  AppButton,
  Box,
  HourglassEptyIcon,
  HourglassIcon,
  useResponsive,
} from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { Banner } from '../BannersList/Banner';

import balanceReminderSessionStorage from './balanceReminderSessionStorage';
import useDismissBalanceReminderStore from './useDismissBalanceReminder.store';
import useGetBalanceReminderQuery from './useGetBalanceReminder.query';

const alertIconParams = { size: '40px', color: theme.colors.danger };

const BalanceReminderBanners = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [isNew, setIsNew] = useState(!balanceReminderSessionStorage.getWatched());
  const { isDismissed, setIsDismissed } = useDismissBalanceReminderStore();
  const { formattedData, isLoading } = useGetBalanceReminderQuery();

  const dismiss = useCallback(() => {
    if (formattedData?.thirtyDaysBeforeBanner) {
      balanceReminderSessionStorage.setThirtyDays();
      setIsDismissed(true);
    }
  }, [formattedData, setIsDismissed]);

  useEffect(() => {
    if (formattedData.thirtyDaysBeforeBanner) {
      setTimeout(() => {
        balanceReminderSessionStorage.setWatched();
        setIsNew(false);
      }, 7000);
    }
  }, [formattedData, setIsNew]);

  if (isDismissed || isLoading || !formattedData?.thirtyDaysBeforeBanner) return null;

  return (
    <Banner
      isNew={isNew}
      title={t('Account Deadline Alert')}
      description={t(
        "Your plan year is coming to an end. Now is a great time to check your account deadlines so you don't lose any money."
      )}
      icon={
        <Box width="98px" height="143px" style={{ position: 'relative' }}>
          <Box width="76px" height="128px" style={{ position: 'absolute', bottom: '0', left: '0' }}>
            {formattedData?.thirtyDaysBeforeBanner ? <HourglassIcon /> : <HourglassEptyIcon />}
          </Box>
          <Box style={{ position: 'absolute', top: '0', right: '0' }}>
            {formattedData?.thirtyDaysBeforeBanner ? (
              <AlertExclamationIcon {...alertIconParams} />
            ) : (
              <AlertDoubleExclamationIcon {...alertIconParams} />
            )}
          </Box>
        </Box>
      }
      testId="BalanceReminderBanners"
    >
      <Box margin={{ top: 'spacing24' }}>
        <AppButton
          fill={isMobile}
          onClick={dismiss}
          width="180px"
          buttonType="secondary"
          testId="BalanceReminderBanners_Dismiss"
        >
          Dismiss
        </AppButton>
      </Box>
    </Banner>
  );
};

export default BalanceReminderBanners;
